// src/utils/ui.js
// Shared utility functions for UI-related logic (e.g., color mapping)

// Helper to determine Chakra UI color scheme based on sensor status
export const getSensorStatusColorScheme = (status) => {
  switch (status?.toLowerCase()) {
    case 'active': return 'green';
    case 'inactive': return 'gray';
    case 'maintenance': return 'orange';
    case 'error': return 'red';
    default: return 'gray';
  }
};

// Helper to determine Chakra UI color scheme based on user role
export const getRoleColorScheme = (role) => {
  switch (role?.toLowerCase()) {
    case 'admin': return 'red';
    case 'staff': return 'blue';
    case 'tech': return 'purple';
    case 'user': return 'green';
    default: return 'gray';
  }
};

// Helper to determine Chakra UI color scheme based on utility status
export const getUtilityStatusColorScheme = (status) => {
  switch (status?.toLowerCase()) {
    case 'operational': return 'green';
    case 'partial_outage': return 'orange';
    case 'full_outage': return 'red';
    case 'maintenance': return 'blue';
    default: return 'gray';
  }
};

// Helper to determine Chakra UI color scheme based on asset status
export const getAssetStatusColorScheme = (status) => {
  switch (status?.toLowerCase()) {
    case 'operational': return 'green';
    case 'maintenance_required': return 'orange';
    case 'damaged': return 'red';
    case 'decommissioned': return 'gray'; // Or red/orange depending on severity
    default: return 'gray'; // Unknown
  }
};

// Helper to determine Chakra UI color scheme based on work order status
export const getWorkOrderStatusColorScheme = (status) => {
  switch (status?.toLowerCase()) {
    case 'pending': return 'yellow';
    case 'in_progress': return 'blue';
    case 'completed': return 'green';
    case 'cancelled': return 'red';
    default: return 'gray'; // Unknown status
  }
};

// Helper to determine pipeline color based on area code (Example)
// This could also be fetched from backend config if dynamic
const areaColors = {
  'AREA1': '#FF0000', // Red
  'AREA2': '#0000FF', // Blue
  'AREA3': '#00FF00', // Green
  'default': '#A0A0A0' // Grey default
};
export const getPipelineColor = (areaCode) => {
  return areaColors[areaCode] || areaColors['default'];
};

// Helper to format utility status label (e.g., replace underscores)
export const formatUtilityStatusLabel = (status) => {
    if (!status) return 'Unknown';
    return status.replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

// --- Added Helper for Predictive Maintenance Alert Severity Color ---
export const getSeverityColorScheme = (severity) => {
  switch (severity?.toLowerCase()) {
    case 'high': return 'red';
    case 'medium': return 'orange';
    case 'low': return 'green';
    case 'critical': return 'purple'; // Example for a very high severity
    default: return 'gray';
  }
};
